import React, { forwardRef } from 'react'
import { ComboBox } from '@zambezi/sdk/dropdown-list'
import LookupField from './LookupField'

/**
 * @template T
 * @template Item
 * @type {React.ForwardRefRenderFunction<React.Ref<HTMLInputElement>, import('./interfaces').ComboBoxFieldProps<T, Item>>}
 * @param {import('./interfaces').ComboBoxFieldProps<T, Item>} props
 * @param {React.Ref<HTMLInputElement>} innerRef
 */
function comboBoxField (props, innerRef) {
  return (
    <LookupField
      {...props}
      ref={innerRef}
      customRenderer={inputOptions => <ComboBox {...inputOptions} />}
    />
  )
}

/**
 * @template T
 * @template Item
 * @type {React.ForwardRefExoticComponent<import('./interfaces').ComboBoxFieldProps<T, Item> & React.RefAttributes<HTMLInputElement>>}
 */
const ComboBoxField = forwardRef(comboBoxField)
ComboBoxField.displayName = 'ComboBoxField'
ComboBoxField.propTypes = LookupField.propTypes

export default ComboBoxField
